import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import { BrandEditComponent } from '@app/modules/settings/pages/brand-edit/brand-edit.component';
import { BrandNewComponent } from '@app/modules/settings/pages/brand-new/brand-new.component';
import { AddTaxDurationComponent } from '@app/modules/settings/pages/settings-taxes/add-tax-duration/add-tax-duration.component';
import { AddTaxReviewComponent } from '@app/modules/settings/pages/settings-taxes/add-tax-review/add-tax-review.component';
import { FindSmartDevicesAddonPipe } from '@app/modules/settings/pipes/find-smart-devices-addon.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { ChargebeeJsAngularWrapperModule } from '@chargebee/chargebee-js-angular-wrapper';
import { AuthorizedDevicesListComponent } from './components/authorized-devices-list/authorized-devices-list.component';
import { BillingFormComponent } from './components/billing-form/billing-form.component';
import { CancelSubscriptionCardComponent } from './components/cancel-subscription-card/cancel-subscription-card.component';
import { CompareFeaturesLinkComponent } from './components/compare-features-link/compare-features-link.component';
import { ConfirmationSummaryComponent } from './components/confirmation-summary/confirmation-summary.component';
import { CurrentBadgeComponent } from './components/current-badge/current-badge.component';
import { DialogDeleteAccountComponent } from './components/dialog-delete-account/dialog-delete-account.component';
import { DialogGuestsForListingComponent } from './components/dialog-guests-for-listing/dialog-guests-for-listing.component';
import { DialogInvitePrimaryHostComponent } from './components/dialog-invite-primary-host/dialog-invite-primary-host.component';
import { DialogSupportTierChangeComponent } from './components/dialog-support-tier-change/dialog-support-tier-change.component';
import { DialogTimeSavedComponent } from './components/dialog-time-saved/dialog-time-saved.component';
import { DowngradeDeleteUsersComponent } from './components/downgrade-delete-users/downgrade-delete-users.component';
import { DowngradeExplanationComponent } from './components/downgrade-explanation/downgrade-explanation.component';
import { DowngradeMutePropertiesComponent } from './components/downgrade-mute-properties/downgrade-mute-properties.component';
import { DowngradeWarningItemComponent } from './components/downgrade-warning-item/downgrade-warning-item.component';
import { DowngradeWarningComponent } from './components/downgrade-warning/downgrade-warning.component';
import { InvoicesTableComponent } from './components/invoices-table/invoices-table.component';
import { ManageSubscriptionWizardFooterComponent } from './components/manage-subscription-wizard-footer/manage-subscription-wizard-footer.component';
import { PaymentCardsComponent } from './components/payment-cards/payment-cards.component';
import { PlanCardComponent } from './components/plan-card/plan-card.component';
import { PlanSummaryComponent } from './components/plan-summary/plan-summary.component';
import { PriceCalloutComponent } from './components/price-callout/price-callout.component';
import { PrioritySupportAddOnComponent } from './components/priority-support-add-on/priority-support-add-on.component';
import { SelectPlanComponent } from './components/select-plan/select-plan.component';
import { SmartDeviceAddOnComponent } from './components/smart-device-add-on/smart-device-add-on.component';
import { SubscriptionDeniedComponent } from './components/subscription-denied/subscription-denied.component';
import { UserManagementFeaturesSelectorComponent } from './components/user-management-features-selector/user-management-features-selector.component';
import { UserManagementProductListComponent } from './components/user-management-product-list/user-management-product-list.component';
import { YourPlanBreakdownComponent } from './components/your-plan-breakdown/your-plan-breakdown.component';
import { YourPlanHeroItemComponent } from './components/your-plan-hero-item/your-plan-hero-item.component';
import { ActivePropertiesComponent } from './pages/active-properties/active-properties.component';
import { BillingDetailsComponent } from './pages/billing-details/billing-details.component';
import { BillingUnavailableComponent } from './pages/billing-unavailable/billing-unavailable.component';
import { GeneralComponent } from './pages/general/general.component';
import { GxComponent } from './pages/gx/gx.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { ManageDeviceAddonComponent } from './pages/manage-device-addon/manage-device-addon.component';
import { ManageSubscriptionWizardComponent } from './pages/manage-subscription-wizard/manage-subscription-wizard.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { PaymentMethodsComponent } from './pages/payment-methods/payment-methods.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { SecurityComponent } from './pages/security/security.component';
import { SettingsOperationsComponent } from './pages/settings-operations/settings-operations.component';
import { SettingsPropertiesComponent } from './pages/settings-properties/settings-properties.component';
import { SettingsSyncComponent } from './pages/settings-sync/settings-sync.component';
import { AddTaxCalculationTypeComponent } from './pages/settings-taxes/add-tax-calculation-type/add-tax-calculation-type.component';
import { AddTaxDescriptionComponent } from './pages/settings-taxes/add-tax-description/add-tax-description.component';
import { AddTaxDoneComponent } from './pages/settings-taxes/add-tax-done/add-tax-done.component';
import { AddTaxIdComponent } from './pages/settings-taxes/add-tax-id/add-tax-id.component';
import { AddTaxScopeComponent } from './pages/settings-taxes/add-tax-scope/add-tax-scope.component';
import { AddTaxSetupComponent } from './pages/settings-taxes/add-tax-setup/add-tax-setup.component';
import { AddTaxTypeComponent } from './pages/settings-taxes/add-tax-type/add-tax-type.component';
import { AddTaxValueComponent } from './pages/settings-taxes/add-tax-value/add-tax-value.component';
import { AddTaxComponent } from './pages/settings-taxes/add-tax/add-tax.component';
import { ListTaxesComponent } from './pages/settings-taxes/list-taxes/list-taxes.component';
import { SettingsTaxesComponent } from './pages/settings-taxes/settings-taxes.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { SubscriptionExpiredComponent } from './pages/subscription-expired/subscription-expired.component';
import { SupportTiersPageComponent } from './pages/support-tiers-page/support-tiers-page.component';
import { UserManagementInviteComponent } from './pages/user-management-invite/user-management-invite.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { YourPlanComponent } from './pages/your-plan/your-plan.component';
import { FindActiveListingsAddonPipe } from './pipes/find-active-listings-addon.pipe';
import { FindBasePrioritySupportAddonPipe } from './pipes/find-base-priority-support-addon.pipe';
import { FindDirectAddonPipe } from './pipes/find-direct-addon.pipe';
import { FindPrioritySupportAddonPipe } from './pipes/find-priority-support-addon.pipe';
import { FindVerificationAddonsPipe } from './pipes/find-verification-addons.pipe';
import { SettingsRoutingModule } from './settings-routing.module';

@NgModule({
  declarations: [
    BrandEditComponent,
    BrandNewComponent,
    ProfileComponent,
    SecurityComponent,
    BillingDetailsComponent,
    GeneralComponent,
    InvoicesComponent,
    UserManagementComponent,
    DialogDeleteAccountComponent,
    GxComponent,
    NotificationsComponent,
    YourPlanComponent,
    YourPlanHeroItemComponent,
    PaymentMethodsComponent,
    PaymentCardsComponent,
    SubscribeComponent,
    BillingFormComponent,
    UserManagementInviteComponent,
    UserManagementProductListComponent,
    UserManagementFeaturesSelectorComponent,
    SubscriptionDeniedComponent,
    BillingUnavailableComponent,
    SettingsPropertiesComponent,
    SettingsOperationsComponent,
    ActivePropertiesComponent,
    DialogGuestsForListingComponent,
    SettingsSyncComponent,
    DialogInvitePrimaryHostComponent,
    SettingsTaxesComponent,
    AddTaxComponent,
    AddTaxIdComponent,
    AddTaxSetupComponent,
    AddTaxDurationComponent,
    AddTaxTypeComponent,
    AddTaxValueComponent,
    AddTaxReviewComponent,
    AddTaxScopeComponent,
    AddTaxDoneComponent,
    AddTaxDescriptionComponent,
    AddTaxCalculationTypeComponent,
    ListTaxesComponent,
    SubscriptionExpiredComponent,
    YourPlanBreakdownComponent,
    FindActiveListingsAddonPipe,
    FindDirectAddonPipe,
    FindBasePrioritySupportAddonPipe,
    FindPrioritySupportAddonPipe,
    FindVerificationAddonsPipe,
    SupportTiersPageComponent,
    DialogSupportTierChangeComponent,
    AuthorizedDevicesListComponent,
    PlanCardComponent,
    SelectPlanComponent,
    ManageSubscriptionWizardComponent,
    PlanSummaryComponent,
    DowngradeWarningComponent,
    DowngradeMutePropertiesComponent,
    DowngradeDeleteUsersComponent,
    CompareFeaturesLinkComponent,
    DowngradeWarningItemComponent,
    FindSmartDevicesAddonPipe,
    ConfirmationSummaryComponent,
    DowngradeExplanationComponent,
    SmartDeviceAddOnComponent,
    PriceCalloutComponent,
    ManageDeviceAddonComponent,
    CurrentBadgeComponent,
    CancelSubscriptionCardComponent,
    DialogTimeSavedComponent,
    InvoicesTableComponent,
    PrioritySupportAddOnComponent,
    ManageSubscriptionWizardFooterComponent,
  ],
  imports: [CommonModule, SettingsRoutingModule, SharedModule, ChargebeeJsAngularWrapperModule, MatStepperModule],
  exports: [],
})
export class SettingsModule {}
